<template>
  <div class="size1 bg0 where1-parent">
    <div
      class="size3 flex-col-sb p-l-50 p-t-25 p-b-44 respon1 reponsive-celular no-print"
    >
      <center class="center-header-login">
        <img
          src="@/assets/LOGO SEPLAG - AZUL (T) VAZADO.svg"
          class="icon-login"
        />
      </center>
      <div class="p-t-5">
        <p class="m1-txt1 p-b-36" style="text-align: center">
          Tabela Salarial do Estado de Mato Grosso
        </p>
        <form ref="formRef" class="p-grid p-fluid">
          <Rotulo nome="Selecione a Carreira:" cols="12">
            <Dropdown
              v-model="carreiraSelecioanda"
              :options="listaCarreira"
              placeholder="Selecione..."
              @change="carregaCargo()"
              filter
            />
          </Rotulo>
          <Rotulo nome="Selecione a Cargo:" cols="12">
            <Dropdown
              v-model="cargoSelecionado"
              :options="listaCargo"
              placeholder="Selecione..."
              filter
              :disabled="listaCargo.length == 0"
              @change="carregaPeriodo()"
            />
          </Rotulo>
          <Rotulo nome="Selecione o Periodo:" cols="12">
            <Dropdown
              v-model="periodoSelecionado"
              :options="listaPeriodo"
              placeholder="Selecione..."
              :disabled="listaPeriodo.length == 0"
              @change="carregaJornada()"
            />
          </Rotulo>
          <Rotulo nome="Selecione a Jornada:" cols="12">
            <Dropdown
              v-model="jornadaSelecionada"
              :options="listaJornada"
              placeholder="Selecione..."
              :disabled="listaJornada.length == 0"
            />
          </Rotulo>
          <br />
          <div class="w-full-sm p-col-12">
            <button
              class="s2-txt2 size4 bg1 bor1 hov1 trans-04"
              type="button"
              @click="gerarTabela()"
            >
              Carregar Tabela
            </button>
          </div>
        </form>
      </div>
      <div class="p-col-12">
        <img src="@/assets/apoio-sti.png" class="img-footer-phone" />
      </div>
    </div>
    <div
      class="flex-c-m bg-img1 size2 where1 overlay1 where2 respon2 display no-print"
      style=""
    ></div>
    <!-- TELA PARA IMPRESSAO -->
    <div class="print p-grid" v-if="tabelaSalarial.length > 0">
      <center class="center-header-login p-col-12">
        <img src="@/assets/logo-seplag.png" class="icon-login" />
      </center>
      <div class="p-col-12" style="text-align: center">
        <h1>
          <strong
            >{{ carreiraSelecioanda ? carreiraSelecioanda : "CARREIRA"
            }}<br />{{ cargoSelecionado ? cargoSelecionado : "CARGO" }}
            <br />{{ periodoSelecionado? "PERIODO SELECIONADO: " + periodoSelecionado: "TOODOS OS PERIODOS" }}</strong
          >
        </h1>
      </div>
      <div
        v-for="(tabela, index) in tabelaSalarial"
        :key="tabela.jornada"
        class="p-col-12"
      >
        <DataTable
          :value="tabela.dadosTabelaSalarial"
          responsiveLayout="stack"
          breakpoint="960px"
          :style="
            index < totalJornada - 1 && jornadaSelecionada == 'TODAS'
              ? 'page-break-after: always;'
              : ''
          "
        >
          <template #header>
            <div class="table-header" style="text-align: center">
              <h3>
                Tabela de Salarial de Carga Horaria de {{ tabela.jornada }}
              </h3>
            </div>
          </template>
          <Column
            field="nivel"
            header="Nível"
            bodyStyle="text-align: center;"
            headerStyle="text-align: center;"
          />
          <Column
            v-for="col in classesCluna"
            :field="col"
            :header="col"
            :key="col"
            bodyStyle="text-align: center;"
            headerStyle="text-align: center;"
          >
            <template #body="slotProps">
              {{ "R$ " + slotProps.data[col] }}
            </template>
          </Column>
        </DataTable>
        <div v-if="index < totalJornada" style="padding-top: 10%"></div>
      </div>
    </div>
    <!-- MODAL DA TABELA SALARIAL -->
    <Dialog
      :visible.sync="exibirModalTabela"
      maximizable
      modal
      class="no-print ajuste-dialogo-tabelaSarial"
    >
      <div class="ajuste-dialogo-tabelaSarial"></div>
      <template #header>
        <div class="p-dialog-title" style="width: 100%; text-align: center">
          <h3>
            {{
              carreiraSelecioanda && cargoSelecionado
                ? carreiraSelecioanda + " - " + cargoSelecionado
                : "CARREIRA - CARGO - TODOS"
            }}
            <br />
            {{ periodoSelecionado? "PERIODO SELECIONADO: " + periodoSelecionado: "TOODOS OS PERIODOS" }}
          </h3>
        </div>
      </template>
      <div class="p-grid" v-if="tabelaSalarial.length > 0">
        <div
          v-for="tabela in tabelaSalarial"
          :key="tabela.jornada"
          :class="
            totalJornada == 2 && jornadaSelecionada == 'TODAS'
              ? 'p-col-12 p-md-6'
              : totalJornada == 3 && jornadaSelecionada == 'TODAS'
              ? 'p-col-12 p-md-4'
              : 'p-col-12'
          "
        >
          <DataTable
            :value="tabela.dadosTabelaSalarial"
            responsiveLayout="stack"
            breakpoint="960px"
          >
            <template #header>
              <div class="table-header" style="text-align: center">
                <h3>
                  Tabela de Salarial de Carga Horaria de {{ tabela.jornada }}
                </h3>
              </div>
            </template>
            <Column
              field="nivel"
              header="Nível"
              bodyStyle="text-align: center;"
              headerStyle="text-align: center;"
            />
            <Column
              v-for="col in classesCluna"
              :field="col"
              :header="col"
              :key="col"
              bodyStyle="text-align: center;"
              headerStyle="text-align: center;"
            >
              <template #body="slotProps">
                {{ "R$ " + slotProps.data[col] }}
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <div class="p-col-12" style="display: flex; justify-content: flex-end">
        <Button
          label="Imprimir"
          icon="pi pi-print"
          iconPos="left"
          @click="imprimir()"
        />
      </div>
    </Dialog>
  </div>
</template>

<script>
import Rotulo from "@/template/RotuloSeplag.vue";
import { baseApiUrl } from "@/config/global";
export default {
  name: "tabelaSalarial-publico",
  components: { Rotulo },
  data: function () {
    return {
      exibirModalTabela: false,
      carreiraSelecioanda: null,
      cargoSelecionado: null,
      jornadaSelecionada: null,
      periodoSelecionado: null,
      totalJornada: null,
      listaCarreira: [],
      listaCargo: [],
      tabelaSalarial: [],
      classesCluna: [],
      listaJornada: [],
      listaPeriodo: [],
    };
  },
  methods: {
    carregarDados() {
      this.$http
        .get(`${baseApiUrl}/publicos/tabelaSalarial/listarCarreira`)
        .then((res) => {
          this.listaCarreira = res.data.sort();
        });
    },
    carregaCargo() {
      this.$http
        .get(
          `${baseApiUrl}/publicos/tabelaSalarial/listarCargo?carreira=${this.carreiraSelecioanda}`
        )
        .then((res) => {
          this.listaCargo = res.data;
          this.cargoSelecionado = null;
          this.periodoSelecionado = null;
          this.jornadaSelecionada = null;
          this.tabelaSalarial = [];
          this.classesCluna = [];
          this.listaJornada = [];
          this.listaPeriodo = [];
        });
    },
    carregaJornada() {
      if (this.periodoSelecionado) {
        let jornadaRequest = {
          carreira: this.carreiraSelecioanda,
          cargo: this.cargoSelecionado,
          periodo: this.periodoSelecionado.split(" - ")[0],
          jornada: null,
        };
        this.$http
          .put(
            `${baseApiUrl}/publicos/tabelaSalarial/listarJornada`,
            JSON.stringify(jornadaRequest)
          )
          .then((res) => {
            this.listaJornada = res.data;
            this.totalJornada = this.listaJornada.length;
            this.tabelaSalarial = [];
            this.classesCluna = [];
            this.listaJornada.push("TODAS");
            this.jornadaSelecionada = "TODAS";
          });
      }
    },
    carregaPeriodo() {
      this.$http
        .get(
          `${baseApiUrl}/publicos/tabelaSalarial/listarPeriodo?carreira=${this.carreiraSelecioanda}&cargo=${this.cargoSelecionado}`
        )
        .then((res) => {
          this.listaPeriodo = res.data.sort(function (a, b) {
            let pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
            let data1 = new Date(
              a.split(" - ")[0].replace(pattern, "$3-$2-$1")
            );
            let data2 = new Date(
              b.split(" - ")[0].replace(pattern, "$3-$2-$1")
            );
            if (data1 > data2) {
              return -1;
            } else {
              return 1;
            }
          });
          this.periodoSelecionado = null;
          this.jornadaSelecionada = null;
          this.listaJornada = [];
        });
    },
    async gerarTabela() {
      this.tabelaSalarial = [];
      this.classesCluna = [];
      let token = null;
      if (process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS != "false") {
        this.$store.commit("setLoader", true);
        await this.$recaptchaLoaded();
        token = await this.$recaptcha("TabelaSalarial");
      }
      if (
        (this.carreiraSelecioanda &&
          this.cargoSelecionado &&
          this.periodoSelecionado &&
          token) ||
        (this.carreiraSelecioanda &&
          this.cargoSelecionado &&
          this.periodoSelecionado &&
          process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS == "false")
      ) {
        let bodyRequest = {
          carreira: this.carreiraSelecioanda,
          cargo: this.cargoSelecionado,
          periodo: this.periodoSelecionado.split(" - ")[0],
          jornada:
            this.jornadaSelecionada == "TODAS" ? null : this.jornadaSelecionada,
        };
        if (this.jornadaSelecionada == "TODAS") {
          this.$http
            .put(
              `${baseApiUrl}/publicos/tabelaSalarial`,
              JSON.stringify(bodyRequest)
            )
            .then((res) => {
              let dadosTabelaSalarial = res.data;
              if (dadosTabelaSalarial.length > 0) {
                let linhaReferencial = {};
                let jornadaReferencial = dadosTabelaSalarial[0].jornada;
                let classeReferencia =
                  dadosTabelaSalarial[0].referencia.split("-")[0];
                let posicao = 0;
                this.tabelaSalarial.push({
                  jornada: jornadaReferencial,
                  dadosTabelaSalarial: [],
                });
                for (let i = 0; i < dadosTabelaSalarial.length; i++) {
                  if (jornadaReferencial == dadosTabelaSalarial[i].jornada) {
                    let linha = dadosTabelaSalarial[i].referencia.split("-");
                    let nivelReferencia = linha[1];
                    if (classeReferencia == linha[0]) {
                      linhaReferencial = {};
                      linhaReferencial["nivel"] = nivelReferencia;
                      linhaReferencial[classeReferencia] = dadosTabelaSalarial[
                        i
                      ].valor.toLocaleString("pt-br", {
                        minimumFractionDigits: 2,
                      });
                      if (this.classesCluna.indexOf(classeReferencia) == -1) {
                        this.classesCluna.push(classeReferencia);
                      }
                      for (let j = i; j < dadosTabelaSalarial.length; j++) {
                        if (
                          jornadaReferencial == dadosTabelaSalarial[j].jornada
                        ) {
                          linha = dadosTabelaSalarial[j].referencia.split("-");
                          if (nivelReferencia == linha[1]) {
                            if (classeReferencia != linha[0]) {
                              linhaReferencial[linha[0]] = dadosTabelaSalarial[
                                j
                              ].valor.toLocaleString("pt-br", {
                                minimumFractionDigits: 2,
                              });
                              if (this.classesCluna.indexOf(linha[0]) == -1) {
                                this.classesCluna.push(linha[0]);
                              }
                            }
                          }
                        }
                      }
                      this.tabelaSalarial[posicao].dadosTabelaSalarial.push(
                        linhaReferencial
                      );
                    }
                  } else {
                    jornadaReferencial = dadosTabelaSalarial[i].jornada;
                    classeReferencia =
                      dadosTabelaSalarial[i].referencia.split("-")[0];
                    this.tabelaSalarial.push({
                      jornada: jornadaReferencial,
                      dadosTabelaSalarial: [],
                    });
                    posicao = posicao + 1;
                    let linha = dadosTabelaSalarial[i].referencia.split("-");
                    let nivelReferencia = linha[1];
                    if (classeReferencia == linha[0]) {
                      linhaReferencial = {};
                      linhaReferencial["nivel"] = nivelReferencia;
                      linhaReferencial[classeReferencia] = dadosTabelaSalarial[
                        i
                      ].valor.toLocaleString("pt-br", {
                        minimumFractionDigits: 2,
                      });
                      if (this.classesCluna.indexOf(classeReferencia) == -1) {
                        this.classesCluna.push(classeReferencia);
                      }
                      for (let j = i; j < dadosTabelaSalarial.length; j++) {
                        if (
                          jornadaReferencial == dadosTabelaSalarial[j].jornada
                        ) {
                          linha = dadosTabelaSalarial[j].referencia.split("-");
                          if (nivelReferencia == linha[1]) {
                            if (classeReferencia != linha[0]) {
                              linhaReferencial[linha[0]] = dadosTabelaSalarial[
                                j
                              ].valor.toLocaleString("pt-br", {
                                minimumFractionDigits: 2,
                              });
                              if (this.classesCluna.indexOf(linha[0]) == -1) {
                                this.classesCluna.push(linha[0]);
                              }
                            }
                          }
                        }
                      }
                      this.tabelaSalarial[posicao].dadosTabelaSalarial.push(
                        linhaReferencial
                      );
                    }
                  }
                }
                if (this.tabelaSalarial.length > 0) {
                  this.exibirModalTabela = true;
                } else {
                  this.$toast.add({
                    severity: "error",
                    summary: "Erro ao montar a tabela salarial",
                    life: 15000,
                  });
                }
              } else {
                this.$toast.add({
                  severity: "error",
                  summary:
                    "Não foi encontrado nenhum valor para os dados informados no formulário",
                  life: 15000,
                });
              }
            });
        } else {
          this.$http
            .put(
              `${baseApiUrl}/publicos/tabelaSalarial`,
              JSON.stringify(bodyRequest)
            )
            .then((res) => {
              let dadosTabelaSalarial = res.data;
              if (dadosTabelaSalarial.length > 0) {
                let linhaReferencial = {};
                let jornadaReferencial = dadosTabelaSalarial[0].jornada;
                let classeReferencia =
                  dadosTabelaSalarial[0].referencia.split("-")[0];
                let posicao = 0;
                this.tabelaSalarial.push({
                  jornada: jornadaReferencial,
                  dadosTabelaSalarial: [],
                });
                for (let i = 0; i < dadosTabelaSalarial.length; i++) {
                  if (jornadaReferencial == dadosTabelaSalarial[i].jornada) {
                    let linha = dadosTabelaSalarial[i].referencia.split("-");
                    let nivelReferencia = linha[1];
                    if (classeReferencia == linha[0]) {
                      linhaReferencial = {};
                      linhaReferencial["nivel"] = nivelReferencia;
                      linhaReferencial[classeReferencia] = dadosTabelaSalarial[
                        i
                      ].valor.toLocaleString("pt-br", {
                        minimumFractionDigits: 2,
                      });
                      if (this.classesCluna.indexOf(classeReferencia) == -1) {
                        this.classesCluna.push(classeReferencia);
                      }
                      for (let j = i; j < dadosTabelaSalarial.length; j++) {
                        if (
                          jornadaReferencial == dadosTabelaSalarial[j].jornada
                        ) {
                          linha = dadosTabelaSalarial[j].referencia.split("-");
                          if (nivelReferencia == linha[1]) {
                            if (classeReferencia != linha[0]) {
                              linhaReferencial[linha[0]] = dadosTabelaSalarial[
                                j
                              ].valor.toLocaleString("pt-br", {
                                minimumFractionDigits: 2,
                              });
                              if (this.classesCluna.indexOf(linha[0]) == -1) {
                                this.classesCluna.push(linha[0]);
                              }
                            }
                          }
                        }
                      }
                      this.tabelaSalarial[posicao].dadosTabelaSalarial.push(
                        linhaReferencial
                      );
                    }
                  } else {
                    jornadaReferencial = dadosTabelaSalarial[i].jornada;
                    classeReferencia =
                      dadosTabelaSalarial[i].referencia.split("-")[0];
                    this.tabelaSalarial.push({
                      jornada: jornadaReferencial,
                      dadosTabelaSalarial: [],
                    });
                    posicao = posicao + 1;
                    let linha = dadosTabelaSalarial[i].referencia.split("-");
                    let nivelReferencia = linha[1];
                    if (classeReferencia == linha[0]) {
                      linhaReferencial = {};
                      linhaReferencial["nivel"] = nivelReferencia;
                      linhaReferencial[classeReferencia] = dadosTabelaSalarial[
                        i
                      ].valor.toLocaleString("pt-br", {
                        minimumFractionDigits: 2,
                      });
                      if (this.classesCluna.indexOf(classeReferencia) == -1) {
                        this.classesCluna.push(classeReferencia);
                      }
                      for (let j = i; j < dadosTabelaSalarial.length; j++) {
                        if (
                          jornadaReferencial == dadosTabelaSalarial[j].jornada
                        ) {
                          linha = dadosTabelaSalarial[j].referencia.split("-");
                          if (nivelReferencia == linha[1]) {
                            if (classeReferencia != linha[0]) {
                              linhaReferencial[linha[0]] = dadosTabelaSalarial[
                                j
                              ].valor.toLocaleString("pt-br", {
                                minimumFractionDigits: 2,
                              });
                              if (this.classesCluna.indexOf(linha[0]) == -1) {
                                this.classesCluna.push(linha[0]);
                              }
                            }
                          }
                        }
                      }
                      this.tabelaSalarial[posicao].dadosTabelaSalarial.push(
                        linhaReferencial
                      );
                    }
                  }
                }
                if (this.tabelaSalarial.length > 0) {
                  this.exibirModalTabela = true;
                }
              } else {
                this.$toast.add({
                  severity: "error",
                  summary:
                    "Não foi encontrado nenhum valor para os dados informados no formulário",
                  life: 15000,
                });
              }
            });
        }
      } else {
        this.$toast.add({
          severity: "error",
          summary:
            "Erro ao enviar, por favor selecione um item em cada campo do formulário e tente novamente",
          life: 15000,
        });
      }
    },
    async carregaRecaptcha() {
      await this.$recaptchaLoaded();
      this.$recaptchaInstance.hideBadge();
    },
    imprimir() {
      window.print();
    },
  },
  mounted() {
    this.carregarDados();
    if (process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS != "false") {
      this.carregaRecaptcha();
    }
  },
};
</script>

<style >
.img-centro {
  text-align: center;
}
.img-atencao {
  width: 36vw;
}
.messages-error {
  background: #ffcdd2;
  border: solid #f44336;
  border-width: 0 0 0 6px;
  color: #b71c1c;
  padding: 1rem 1.5rem;
}

.messages-info {
  background: #b3e5fc;
  border: solid #03a9f4;
  border-width: 0 0 0 6px;
  color: #01579b;
  padding: 1rem 1.5rem;
}

.imagem-fundo {
  background: url("../../assets/img-direito.png");

  background-position: 0% 45%;
  background-repeat: round;
  background-size: auto;
  height: 100.8vh;
  flex-grow: 1;
}

.p-dialog-mask .ajuste-dialogo-tabelaSarial {
  width: 70%;
}

.img-sti {
  margin-bottom: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  width: 8%;
}

.texto-sistema {
  font-size: 20px;
  color: #005494;
  font-weight: bold;
  padding: 0;
  margin: 0;
}

.logingridcontrol1 {
  background-color: #005494;
  background: url("../../assets/layout/img-login-pessoas.jpg");
  background-size: 105%;
  height: 75%;
  min-height: 75%;
}
.logingridcontrol2 {
  min-height: 75%;
  height: 75%;
  background-color: #fff;
}

.logingridcontrol2 .border {
  border: 1px dashed #005494;
  margin-top: 2px;
  border-left: 0;
  height: 100%;
}
.p-grid {
  margin-right: 0;
  margin-left: 0;
}

.loginformgvesqueci a {
  color: white;
}
.bg1 {
  background-color: #007ad9;
}
.bg2 {
  background-color: green;
}

.wrap-pic1 {
  width: 70%;
}
.bg-img1 {
  background-image: url("../../assets/tabelaSalarial.png");
}
.texto-sistema {
  font-size: 40px;
  color: #005494;
  font-weight: bold;
  padding: 0;
  margin: 0;
}
.icon-login {
  width: 50%;
  margin-top: 4vw;
  margin-bottom: 4vw;
  margin-left: -2.2vw;
}
.img-top-phone {
  width: 90%;
  margin-top: 12vw;
  margin-left: -6vw;
}
.img-footer-phone {
  width: 12vw;
  margin-left: 8vw;
  margin-top: 4vw;
}
.m1-txt1 {
  font-size: 15px;
}
.s2-txt4 {
  text-transform: none;
  font-family: "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 15px;
}
.bor2 {
  text-align: center;
  cursor: pointer;
}

.confirmation-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.view-phone {
  display: none;
}
.print {
  display: none;
}
div.p-dropdown {
  padding: 0 22px 0 22px;
  width: 100%;
  border: 2px solid #e6e6e6;
  font-family: "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 15px;
  line-height: 2.5;
  width: 100%;
}
@media screen and (max-width: 48em) {
  .img-atencao {
    width: 100% !important;
  }
  .display {
    display: none !important;
  }
  .reponsive-celular {
    padding-right: 26px !important;
    padding-left: 18px !important;
  }
  .wrap-pic1 {
    width: 100%;
  }
  .view-phone {
    display: block;
  }
  .logingridcontrol1 {
    display: none;
  }
  .texto-sistema {
    margin-top: 12vw;
  }
  .img-footer-phone {
    width: 37vw;
    margin-left: 25vw;
    margin-top: 25vw;
  }

  div.p-dropdown {
    padding: 0 !important;
  }
  .p-dropdown-panel {
    left: -2rem;
  }

  .p-dialog-mask .ajuste-dialogo-tabelaSarial {
    width: 100%;
    max-width: 100%;
  }
}
/*CSS para impressão*/
@media print {
  .icon-login {
    width: 60%;
    margin-top: 4vw;
    margin-bottom: 3vw;
    margin-left: -2vw;
  }
  .no-print {
    display: none;
  }
  .print {
    display: block;
  }
  h1 {
    font-size: 18px;
  }
  h3 {
    font-size: 14px;
  }
  td {
    font-size: 12px;
  }
}
</style>